'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _funds_repository = require('../repository/funds_repository.js');

var _funds_repository2 = _interopRequireDefault(_funds_repository);

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _spinner_utility = require('../../../packages/common-utilities/src/spinner_utility.js');

var _spinner_utility2 = _interopRequireDefault(_spinner_utility);

var _error_component = require('./global_components/error_component.js');

var _error_component2 = _interopRequireDefault(_error_component);

var _redirect_to_fund_documents = require('./redirect_to_fund_documents.js');

var _redirect_to_fund_documents2 = _interopRequireDefault(_redirect_to_fund_documents);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _locale_utility = require('../../../packages/common-utilities/src/locale_utility');

var _ramda = require('ramda');

var _cms_utility = require('../../../packages/common-utilities/src/cms_utility');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _disclosures_override_config = require('common-utilities/src/disclosures_override_config');

var _functional_utility2 = require('common-utilities/src/functional_utility');

var _fund_utility = require('common-utilities/src/fund_utility');

var _fundsmarketing_aem_service = require('../services/fundsmarketing_aem_service');

var _fundsmarketing_aem_service2 = _interopRequireDefault(_fundsmarketing_aem_service);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundProvider = function (_React$Component) {
  _inherits(FundProvider, _React$Component);

  function FundProvider(props) {
    _classCallCheck(this, FundProvider);

    var _this = _possibleConstructorReturn(this, (FundProvider.__proto__ || Object.getPrototypeOf(FundProvider)).call(this, props));

    _this.state = {};
    (0, _locale_utility.addAppLocaleData)();
    return _this;
  }

  _createClass(FundProvider, [{
    key: 'getLabelServiceUrl',
    value: function getLabelServiceUrl(url, country, language) {
      var result = this.props.gaiaRedirectUrl + url;
      result += '?country=' + country;
      if (language) {
        result += '&language=' + language;
      }
      result += '&version=8.8_1746361865';
      return result;
    }
  }, {
    key: 'getServiceUrl',
    value: function getServiceUrl(url) {
      return this.props.gaiaRedirectUrl + url;
    }
  }, {
    key: 'overrideDisclosures',
    value: function overrideDisclosures(freshFundState) {
      var _props = this.props,
          content = _props.content,
          role = _props.role,
          country = _props.country;

      var contentDisclosuresIsNull = (0, _ramda.pathSatisfies)(_ramda.isNil, ["disclosures"], content);
      this.appendHelpText(freshFundState);
      if (contentDisclosuresIsNull || (0, _ramda.isNil)(freshFundState.fund)) {
        return freshFundState;
      } else {
        freshFundState.fund.disclosures = (0, _ramda.mergeDeepRight)(freshFundState.fund.disclosures, this.getSiteSpecificDisclosures(_extends({}, content.disclosures), freshFundState, role, country));
      }
    }
  }, {
    key: 'overrideCommentaries',
    value: function overrideCommentaries(freshFundState) {
      var _props2 = this.props,
          content = _props2.content,
          role = _props2.role,
          country = _props2.country;

      var htmlCommentariesIsNull = (0, _ramda.pathSatisfies)(_ramda.isNil, ["htmlCommentaries"], content);
      if (htmlCommentariesIsNull || (0, _ramda.isNil)(freshFundState.fund)) {
        return freshFundState;
      } else if (!(0, _ramda.isNil)(freshFundState.fund.shareClass)) {
        freshFundState.fund.shareClass.htmlCommentaries = (0, _ramda.mergeDeepRight)(freshFundState.fund.shareClass.htmlCommentaries, _extends({}, content.htmlCommentaries), freshFundState, role, country);
      }
    }
  }, {
    key: 'appendHelpText',
    value: function appendHelpText(freshFundState) {
      if (!(0, _ramda.isNil)(freshFundState.fund) && !(0, _functional_utility2.isNilOrEmpty)(freshFundState.fund.helpText) && !(0, _ramda.pathSatisfies)(_ramda.isNil, ["visibleData", "visibleDataPoints"], freshFundState.fund) && (_collection_utility.CollectionUtility.includes(freshFundState.fund.visibleData.visibleDataPoints, 'SHOW_HELP_TEXT') || _collection_utility.CollectionUtility.includes(freshFundState.fund.visibleData.visibleDataPoints, 'SHOW_DISCLOSURE_ON_DOCUMENT_LEGAL_CARD'))) {
        freshFundState.fund.disclosures = _extends({}, freshFundState.fund.disclosures, freshFundState.fund.helpText);
      }
      return freshFundState;
    }
  }, {
    key: 'getSiteSpecificDisclosures',
    value: function getSiteSpecificDisclosures(disclosures, freshFundState, role, country) {
      var pdpBottomDisclosures = [];
      var visibleDataPoints = (0, _ramda.pathOr)([], ["visibleData", "visibleDataPoints"], freshFundState.fund);

      if (role === "adv" && !_collection_utility.CollectionUtility.includes(visibleDataPoints, 'SHOW_PDP_ROLE_SPECIFIC_BOTTOM_DISCLOSURE') && !(0, _ramda.isNil)(disclosures.pdpBottomAllAdvEmea)) {
        disclosures.pdpBottomAllAdvEmea.map(function (disc) {
          return pdpBottomDisclosures.push(disc);
        });
      }

      if (!(0, _ramda.isNil)(disclosures.pdpBottomAllEmea)) {
        disclosures.pdpBottomAllEmea.map(function (disc) {
          return pdpBottomDisclosures.push(disc);
        });
      }

      if (_collection_utility.CollectionUtility.includes(visibleDataPoints, 'SHOW_FUND_NAME_DISCLOSURE')) {
        disclosures.FundNameDisclosure = freshFundState.fund.disclosures['FundNameDisclosure'];
      }

      disclosures.pdpBottomAll = (0, _ramda.isNil)(disclosures.pdpBottomAll) ? pdpBottomDisclosures : [].concat(_toConsumableArray(disclosures.pdpBottomAll), pdpBottomDisclosures);

      if (!(0, _ramda.isNil)((0, _ramda.path)([country, role], _disclosures_override_config.PDP_OVERRIDE_DISCLOSURES_CONFIG))) {
        var configKeys = (0, _ramda.keys)(_disclosures_override_config.PDP_OVERRIDE_DISCLOSURES_CONFIG[country][role]);
        configKeys.map(function (key) {
          return disclosures[key] = disclosures[FundProvider.getDisclosureKeyToOverride(country, role, key)];
        });
      }

      return disclosures;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var isUSAdvCommingledNotLoggedIn = !this.props.userLoggedIn && this.props.country === 'us' && this.props.role === 'adv' && this.props.fundTypeCode === "Commingled";
      if (isUSAdvCommingledNotLoggedIn) {
        _spinner_utility2.default.stopSpinner();
        _fundsmarketing_aem_service2.default.invokeLoginModal();
        return;
      }

      if ((0, _cms_utility.isAEM)(this.props)) {
        this.getFundDataAndAEMDocuments;
      } else {
        _funds_repository2.default.getFundDataAndOWCSDocuments(this.props.userLoggedIn, this.props.cusip, this.props.country, this.props.language, this.props.role, this.getServiceUrl('/product-data'), this.getServiceUrl('/content-documents')).then(function (freshFundState) {
          _this2.appendHelpText(freshFundState);
          _this2.setState(freshFundState);
        }, function () {
          _this2.getFundData;
        });
      }
      var labelService = this.getLabelServiceUrl('/fund-explorer-label', (0, _locale_utility.getDefaultCountryForTranslatedLabels)(this.props.country, this.props.role), this.props.language);
      _jquery2.default.get('' + labelService).then(function (data) {
        _this2.setState({ labelData: data });
      });
    }
  }, {
    key: 'getAEMDocumentServiceUrl',
    value: function getAEMDocumentServiceUrl() {
      return (0, _ramda.isNil)(this.props.documentServiceUrl) ? '' : this.props.documentServiceUrl;
    }
  }, {
    key: 'getInvestmentComparisonData',
    value: function getInvestmentComparisonData(freshFundState) {
      var _this3 = this;

      var figiIDs = [];
      _funds_repository2.default.getInvestmentComparisonData(freshFundState.fund.shareClass.ticker, this.props.country, this.props.language, this.props.role, freshFundState.fund.currencyCode, this.getServiceUrl('/ic-product-comparison'), this.getServiceUrl('/ic-autocomplete'), figiIDs).then(function (icFundState) {
        _this3.setState({ icData: { data: icFundState.comparisonData, figiIDs: figiIDs } });
      }, function () {
        _this3.setState({ icMessageStatus: 'ic initialization error' });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.redirectToFundDocuments) {
        return _react2.default.createElement(_reactIntl.IntlProvider, {
          locale: (0, _locale_utility.getDefaultLocale)(this.props.country, this.props.language, this.props.role),
          defaultLocale: (0, _locale_utility.getDefaultLocale)(this.props.country, this.props.language, this.props.role),
          messages: this.state.labelData
        }, _react2.default.createElement(_redirect_to_fund_documents2.default, _collection_utility.CollectionUtility.merge({ messageKey: this.state.messageStatus }, { window: this.props.window }, { country: this.props.country }, { role: this.props.role }, { language: this.props.language }, { isAEM: (0, _cms_utility.isAEM)(this.props) })));
      }

      if (!(0, _ramda.isNil)(this.state.messageStatus) && this.state.messageStatus !== '') {
        var errorMessage = this.getErrorMessage();
        return _react2.default.createElement(
          'div',
          { className: 'padding-top-50' },
          _react2.default.createElement(_error_component2.default, { errorMessage: errorMessage,
            country: this.props.country,
            role: this.props.role,
            language: this.props.language
          })
        );
      }
      if (!this.state.fund) {
        return null;
      }
      return _react2.default.createElement(_reactIntl.IntlProvider, {
        locale: (0, _locale_utility.getDefaultLocale)(this.props.country, this.props.language, this.props.role),
        defaultLocale: (0, _locale_utility.getDefaultLocale)(this.props.country, this.props.language, this.props.role),
        messages: this.state.labelData
      }, _react2.default.createElement(this.props.children.type, _collection_utility.CollectionUtility.merge({ messages: this.state.labelData }, { fund: this.state.fund }, { icData: this.state.icData }, { icMessageStatus: this.state.icMessageStatus }, this.props)));
    }
  }, {
    key: 'getErrorMessage',
    value: function getErrorMessage() {
      var errorMessage = this.props.role === _constants2.default.getAccessFundsRole() ? _constants2.default.getErrorMessage(this.state.messageStatus + '-access-funds') : _constants2.default.getErrorMessage(this.state.messageStatus);
      var labelMessageError = (this.state.labelData || {})[this.state.messageStatus] || "";
      if (!(0, _functional_utility.isDataEmpty)(labelMessageError)) {
        errorMessage = labelMessageError;
      }
      return errorMessage;
    }
  }, {
    key: 'getFundData',
    get: function get() {
      var _this4 = this;

      _funds_repository2.default.getFundData(this.props.userLoggedIn, this.props.cusip, this.props.country, this.props.language, this.props.role, this.getServiceUrl('/product-data')).then(function (freshFundState) {
        _this4.overrideDisclosures(freshFundState);
        _this4.setState(freshFundState);
      }, function () {
        _spinner_utility2.default.stopSpinner();
        _this4.setState({ messageStatus: 'pdp-edpi-service-error' });
      });
    }
  }, {
    key: 'getFundDataAndAEMDocuments',
    get: function get() {
      var _this5 = this;

      _funds_repository2.default.getFundDataAndAEMDocuments(this.props.userLoggedIn, this.props.cusip, this.props.country, this.props.language, this.props.role, this.getServiceUrl('/product-data'), this.getAEMDocumentServiceUrl()).then(function (freshFundState) {
        _this5.overrideDisclosures(freshFundState);
        _this5.overrideCommentaries(freshFundState);
        if (_collection_utility.CollectionUtility.includes((0, _ramda.pathOr)([], ["visibleData", "visibleDataPoints"], freshFundState.fund), 'SHOW_FUND_FAVORITE_LINK') && _this5.props.userLoggedIn === true && typeof _this5.props.invokeGetCollection === "function") {
          _fundsmarketing_aem_service2.default.getFavoriteFundsCollectionData().then(function (data) {
            if (!(0, _functional_utility2.isNilOrEmpty)(data)) {
              freshFundState.fund.isFavoriteFund = (0, _fund_utility.isFavoriteFund)(data, _this5.props.cusip);
            }
            _this5.setState(freshFundState);
          });
        } else {
          _this5.setState(freshFundState);
        }
        if (_collection_utility.CollectionUtility.includes((0, _ramda.pathOr)([], ["visibleData", "visibleDataPoints"], freshFundState.fund), 'SHOW_INVESTMENT_COMPARISON_LITE')) {
          _this5.getInvestmentComparisonData(freshFundState);
        }
      }, function () {
        _spinner_utility2.default.stopSpinner();
        _this5.setState({ messageStatus: 'pdp-edpi-service-error' });
      });
    }
  }], [{
    key: 'getDisclosureKeyToOverride',
    value: function getDisclosureKeyToOverride(country, role, defaultPlacementId) {
      return (0, _ramda.pathOr)(defaultPlacementId, [country, role, defaultPlacementId], _disclosures_override_config.PDP_OVERRIDE_DISCLOSURES_CONFIG);
    }
  }]);

  return FundProvider;
}(_react2.default.Component);

exports.default = FundProvider;